import { Routes, Route } from "react-router-dom";
import React from "react";
import WidgetWA from "./WidgetWA";
import LinkGen from "./LinkGen";
import WaCalculator from "./WaCalculator";
import WaNotification from "./WaNotification";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/code-wa" element={<WidgetWA channel='wa'/>} />
        <Route path="/code-tg" element={<WidgetWA channel='tg'/>} />
        <Route path="/code-line" element={<WidgetWA channel='line'/>} />
        <Route path="/code-viber" element={<WidgetWA channel='viber'/>} />
        <Route path="/wa" element={<LinkGen channel='wa' />} />
        <Route path="/tg" element={<LinkGen channel='tg' />} />
        <Route path="/line" element={<LinkGen channel='line' />} />
        <Route path="/viber" element={<LinkGen channel='viber' />} />
        <Route path="/calc" element={<WaCalculator />} />
        <Route path="/wa-notification" element={<WaNotification />} />
      </Routes>
    </div>
  );
}

export default App;
